// https://redwoodjs.com/tutorial/layouts
import { Link, routes } from '@redwoodjs/router'; // https://redwoodjs.com/tutorial/routing-params
import 'src/layouts/main.scss';

const MainLayout = ({ children }) => {
  return (
    <div>
      <div className="container-fluid">
        <h1>
          <Link to={routes.home()}>VoteQuickly.com</Link>
        </h1>
        {children}
      </div>
      <footer>
        <Link to={routes.home()}>Home</Link> • <Link to={routes.about()}>About</Link> •{' '}
        <Link to={routes.contact()}>Contact Us (Suggest a Feature, Report a Problem, Donate / Sponsor This Project, etc)</Link>
      </footer>
    </div>
  );
};

export default MainLayout;
